import { TutorialPageKey } from './tutorialConfig';

export const SETUP_GUIDE_TOUR_RUNNING_KEY = 'finz:setup-guide-tour-running';
export const SETUP_GUIDE_TOUR_PAGE_KEY = 'finz:setup-guide-tour-page';

export const isTutorialRuntimeActive = (...pageKeys: TutorialPageKey[]) => (
    typeof window !== 'undefined'
    && sessionStorage.getItem(SETUP_GUIDE_TOUR_RUNNING_KEY) === 'true'
    && pageKeys.includes(sessionStorage.getItem(SETUP_GUIDE_TOUR_PAGE_KEY) as TutorialPageKey)
);

export const setTutorialRuntimePage = (pageKey: TutorialPageKey) => {
    sessionStorage.setItem(SETUP_GUIDE_TOUR_RUNNING_KEY, 'true');
    sessionStorage.setItem(SETUP_GUIDE_TOUR_PAGE_KEY, pageKey);
    window.dispatchEvent(new CustomEvent('finz:tutorial:active', { detail: { pageKey } }));
};

export const clearTutorialRuntime = () => {
    const pageKey = sessionStorage.getItem(SETUP_GUIDE_TOUR_PAGE_KEY);
    sessionStorage.removeItem(SETUP_GUIDE_TOUR_RUNNING_KEY);
    sessionStorage.removeItem(SETUP_GUIDE_TOUR_PAGE_KEY);
    window.dispatchEvent(new CustomEvent('finz:tutorial:active', { detail: { pageKey, active: false } }));
};
